// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mm-0";
export var discountCodeInput = "_mm-1";